import { Component, Input, Optional } from '@angular/core';
import { RentalsService } from '../../../../../../../../services/rentals.service';
import { HelpersService } from '../../../../../../../../services/helpers.service';
import { TranslateService } from '@ngx-translate/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { MessageService } from 'primeng/api';

import moment from 'moment';

@Component({
  selector: 'app-reservation-product-service-indicator',
  templateUrl: './reservation-product-service-indicator.component.html',
  styleUrls: ['./reservation-product-service-indicator.component.scss'],
  providers: [MessageService]
})
export class ReservationProductServiceIndicatorComponent {

  @Input() serviceIndicatorRecords: any[] = [];
  @Input() reservation: any = {};
  @Input() isModal: boolean = false;

  public partnerData: any = {};

  constructor(
    private helpersService: HelpersService,
    private rentalsService: RentalsService,
    private translate: TranslateService,
    public messageService: MessageService,
    @Optional() public modal: NgbActiveModal
  ) {
    this.partnerData = this.helpersService.getPartnerData();
  }


  ngOnChanges(): void {
    
  }
  ngOnInit(): void {
    this.serviceIndicatorRecords.forEach((record) => {
      if(record.absoluteValue > 0) {
        record.updated = true;
      }
    });
  }

  updateServiceIndicatorRecord(record) {
    console.log("Updating service indicator record", record);
    if (record.absoluteValue > 0 && !record.updated) {
      var data = {
        ...record,
        defaultPartnerId: this.helpersService.getPartnerId(),
        eventDate: moment().toDate(),
      }
      this.rentalsService.captureServiceIndicatorValue(data).subscribe((response) => {
        record.updated = true;
        this.messageService.add({
          key: 'service-indicator-update',
          detail: record.metric == "Mileage" ? this.translate.instant("bikeshop.rentals.products.mileage_updated") : this.translate.instant("bikeshop.rentals.products.hours_updated")
        });
      }, err => {

      });
    }

  }

  isValid(){
    var valid = true;
    this.serviceIndicatorRecords.forEach((record) => {
      if (record.absoluteValue <= 0 || record.absoluteValue == null) {
        valid = false;
      }
    });
    return valid;
  }

}
